import React, { useEffect, useState } from "react";
import { List, Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import NavigationMenu from "./NavigationMenu";
import SidebarMenus from "./admin.routes";
import { SIDEBAR_MENU_CONFIG } from "./SidebarMenu.config";

const SidebarV2 = () => {
  const location = useLocation();

  // Sidebar Styling config
  const { sidebar_box, sidebar_list } = SIDEBAR_MENU_CONFIG;

  // Track which menus are open
  const [openMenus, setOpenMenus] = useState({
    "Master Data": true,
    "Pricing Engine": false,
    "Rate Card": false,
  });

  const handleMenuClick = (label) => {
    setOpenMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  // Helper to check if a path is active
  const isActive = (path) => location.pathname === path;

  // Helper to check if any child path is active for a parent
  const isAnyChildActive = (children) =>
    children && children.some((child) => isActive(child.path));

  // Effect to automatically open parent menus when child routes are active
  // and close other menus
  useEffect(() => {
    const newOpenMenus = {};
    let hasChanges = false;

    // First, close all menus
    SidebarMenus.forEach((item) => {
      newOpenMenus[item.label] = false;
    });

    // Then, open only the menu that has an active child
    SidebarMenus.forEach((item) => {
      if (item.children && isAnyChildActive(item.children)) {
        newOpenMenus[item.label] = true;
        hasChanges = true;
      }
    });

    // Check if we're on a direct route (not a child route)
    const currentItem = SidebarMenus.find((item) => 
      item.path && isActive(item.path)
    );
    
    if (currentItem) {
      // If we're on a direct route, keep all menus closed
      hasChanges = true;
    }

    if (hasChanges) {
      setOpenMenus(newOpenMenus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <Box sx={{ ...sidebar_box }}>
      <List component="nav" sx={{ ...sidebar_list }}>
        {SidebarMenus.map((item) =>
          item.children ? (
            <NavigationMenu
              key={item.label}
              label={item.label}
              icon={item.icon}
              open={openMenus[item.label]}
              onClick={() => handleMenuClick(item.label)}
              selected={isAnyChildActive(item.children)}
              showNested={true}
            >
              {item.children.map((child) => (
                <NavigationMenu
                  key={child.label}
                  label={child.label}
                  icon={child.icon}
                  path={child.path}
                  selected={isActive(child.path)}
                  isNested
                  showNested={false}
                />
              ))}
            </NavigationMenu>
          ) : (
            <NavigationMenu
              key={item.label}
              label={item.label}
              icon={item.icon}
              path={item.path}
              selected={isActive(item.path)}
              showNested={false}
            />
          )
        )}
      </List>
    </Box>
  );
};

export default SidebarV2;
